const searchButton = document.querySelector(".btn-site-search");

if (searchButton) {
    searchButton.addEventListener('click', () => {
        if (!document.querySelector("#___gcse_0")) {
            const cx = '013148484897922495566:ysihwchlzvs';
            const gcse = document.createElement('script');
            gcse.type = 'text/javascript';
            gcse.async = true;
            gcse.src = `${(document.location.protocol === 'https:' ? 'https:' : 'http:')}//cse.google.com/cse.js?cx=${cx}`;
            const s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(gcse, s);
        } else {
            return;
        }
    });

    const observer = new MutationObserver((m) => {
        if (m[0].addedNodes[0].id === "___gcse_0") {
            document.querySelector('#nav-search .symbol-container-spinner-white').style.display = "none";
        }
    });

    observer.observe(document.querySelector('#nav-search .google-search'), {childList: true});
}

if (document.location.pathname === '/search' && !document.querySelector("#___gcse_0")) {
    const cx = '013148484897922495566:ysihwchlzvs';
    const gcse = document.createElement('script');
    gcse.type = 'text/javascript';
    gcse.async = true;
    gcse.src = `${(document.location.protocol === 'https:' ? 'https:' : 'http:')}//cse.google.com/cse.js?cx=${cx}`;
    const s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(gcse, s);
}

